var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active animated bounceIn",attrs:{"id":"cart-recovered-notice"},on:{"click":function($event){_vm.$store.state.showCartRecoveredNotice = false}}},[_c('span',[_vm._v("היי, יש לך פריטים בעגלה מהביקור האחרון.")]),_c('u',[_vm._v("OK")])])
}
var staticRenderFns = []

export { render, staticRenderFns }